import React from "react";
import { Dot, Load } from "./LoaderStyles";

function Loader(props) {
  return (
    <Load>
      <Dot style={{ background: props.color }}></Dot>
      <Dot style={{ background: props.color }}></Dot>
      <Dot style={{ background: props.color }}></Dot>
    </Load>
  );
}

export default Loader;
